import type { QueryClient } from '@tanstack/react-query';
import { WS_MESSAGE_TYPE } from 'cpool-constants';
import { schemaWsNotificationsMessage } from 'cpool-schemas';

import {
    NOTIFICATION_DEPENDENT_QUERY_KEYS_BY_KIND,
    NOTIFICATION_QUERY_KEY_BY_KIND,
} from '~/features/notifications/constants';
import { getQueryPosition, setQueryPosition } from '~/store/queryPositionStore';

// malformed frames (e.g. a kind this build doesn't know yet) are warned and ignored
export function handleNotificationsSocketMessage({
    message,
    queryClient,
}: {
    message: { type?: unknown; kind?: unknown; position?: unknown };
    queryClient: QueryClient;
}): void {
    if (message.type !== WS_MESSAGE_TYPE.NOTIFICATIONS) return;
    const parsed = schemaWsNotificationsMessage.safeParse(message);
    if (!parsed.success) {
        console.warn('handleNotificationsSocketMessage: ignoring malformed notifications push', message);
        return;
    }
    const { kind, position } = parsed.data;

    const queryKey = NOTIFICATION_QUERY_KEY_BY_KIND[kind];
    const positionKey = JSON.stringify(queryKey);
    const storedPosition = getQueryPosition(positionKey);
    // only raised (out-of-order pushes); a new position changes the query key and refetches - no invalidate needed
    if (position !== undefined && (storedPosition === undefined || position > Number(storedPosition))) {
        setQueryPosition(positionKey, position);
    } else {
        queryClient.invalidateQueries({ queryKey });
    }

    NOTIFICATION_DEPENDENT_QUERY_KEYS_BY_KIND[kind]?.forEach((dependentKey) =>
        queryClient.invalidateQueries({ queryKey: dependentKey }),
    );
}
